export const TALENT_PROFILE_DATA = {
    id: '1',
    profile: {
        name: 'Jacques Dupont',
        gender: 'Homme',
        applications: 12,
        location: 'Paris',
        joinDate: 'Jan 2025',
        rating: 4,
        comments: 9,
        tags: ['Hair stylist', 'Designer', 'Business Manager'],
        availability: 'CDI temps plein, CDI temps partiel (Contrat souhaité)',
    },
    contact: {
        email: 'jacquest@gmail.com',
        website: 'www.JDupont.Com',
        phone: '+33 8 72 48 91 27',
        instagram: '@Jacques',
        linkedin: 'linkedin.com/in/ghozi47/',
        tiktok: 'tiktok.com/barer',
    },
    bio: 'Lorem ipsum dolor sit amet consectetur. Elit urna ac lorem proin diam turpis morbi. Nibh tristique in volutpat nec dui. Velit faucibus tellus morbi pellentesque blandit at. Pellentesque convallis eu duis sit lacus vel egestas. Tellus pellentesque blandit volutpat et nibh quam tortor. Lorem ipsum dolor sit amet consectetur. Elit urna ac lorem proin diam turpis morbi. Nibh tristique in volutpat nec dui. Velit faucibus tellus morbi pellentesque blandit at. Pellentesque convallis eu duis sit lacus vel egestas. Tellus pellentesque blandit volutpat et nibh quam tortor.',
    salary: {
        current: '1 750 €',
        desired: '2 320 €',
    },
    experiences: [
        {
            company: 'Confidences - le salon',
            expirence: [
                {
                    title: 'Coiffeur - Coloriste',
                    location: 'Lyon',
                    period: "Oct 2020 - aujourd'hui",
                    duration: '(2 ans 1 mois)',
                    description:
                        "Coiffeur au sein du salon Confidences Croix-rousse, je suis spécialiste couleurs et coiffeur. J'ai en charge la formation d'un apprenti et manage 2 autres coiffeurs.",
                    skills: ['Couleur', 'Coupe structurée', 'Mariée'],
                },
                {
                    title: 'Coiffeur - Coloriste',
                    location: 'Lyon',
                    period: "Oct 2020 - aujourd'hui",
                    duration: '(2 ans 1 mois)',
                    description:
                        "Coiffeur au sein du salon Confidences Croix-rousse, je suis spécialiste couleurs et coiffeur. J'ai en charge la formation d'un apprenti et manage 2 autres coiffeurs.",
                    skills: ['Couleur', 'Coupe structurée', 'Mariée'],
                },
            ],
        },
        {
            company: 'Confidences - le salon',
            expirence: [
                {
                    title: 'Coiffeur - Coloriste',
                    location: 'Lyon',
                    period: "Oct 2020 - aujourd'hui",
                    duration: '(2 ans 1 mois)',
                    description:
                        "Coiffeur au sein du salon Confidences Croix-rousse, je suis spécialiste couleurs et coiffeur. J'ai en charge la formation d'un apprenti et manage 2 autres coiffeurs.",
                    skills: ['Couleur', 'Coupe structurée', 'Mariée'],
                },
            ],
        },
    ],
    hardSkills: ['Hipster', 'Haircolor', 'Hair Dressing', 'Tattoo artist', 'Dummy', 'Dummy', 'Dummy', 'Dummy', 'Dummy'],
    softSkills: [
        'Communication',
        'Teamwork',
        'Adaptability',
        'Problem Solving',
        'Creativity',
        'Critical Thinking',
        'Time Management',
        'Leadership',
        'Emotional Intelligence',
        'Conflict Resolution',
        'Project Management',
        'Decision Making',
        'Networking',
    ],
    education: [
        {
            title: 'BP Coiffure - Alternance',
            school: 'Ecole de coiffure Lyon',
            period: '2013 - 2015',
            level: 'Niveau : Mention assez Bien',
        },
        {
            title: 'BP Coiffure - Alternance',
            school: 'Ecole de coiffure Lyon',
            period: '2013 - 2015',
            level: 'Niveau : Mention assez Bien',
        },
        {
            title: 'BP Coiffure - Alternance',
            school: 'Ecole de coiffure Lyon',
            period: '2013 - 2015',
            level: 'Niveau : Mention assez Bien',
        },
        {
            title: 'BP Coiffure - Alternance',
            school: 'Ecole de coiffure Lyon',
            period: '2013 - 2015',
            level: 'Niveau : Mention assez Bien',
        },
    ],
    certifications: [
        {
            title: 'Certification UX Design Coursera par Google',
            organization: 'Coursera',
            certNumber: '202505075AAA',
            period: 'Obtention Mar 2022 - Expire Mar 2025',
        },
        {
            title: 'Certification UX Design Coursera par Google',
            organization: 'Coursera',
            certNumber: '202505075AAA',
            period: 'Obtention Mar 2022 - Expire Mar 2025',
        },
        {
            title: 'Certification UX Design Coursera par Google',
            organization: 'Coursera',
            certNumber: '202505075AAA',
            period: 'Obtention Mar 2022 - Expire Mar 2025',
        },
    ],
};

export const TALENT_ITEM_DATA = {
    id: '1',
    name: 'Jacques Dupont',
    candidatures: 12,
    date: '13.01.25',
    time: '14:30',
    location: 'Lyon',
    status: 'open',
    rating: 4,
};
